<template>
  <el-card class="ibox">
    <div slot="header" class="flex justify-between">
      <div>{{ $t('shopSms.smsSettings') }}</div>
      <div class="flex justify-end">
        <el-button type="primary" size="small" @click="openEditShopSmsSwitchModel">
          {{ $t('shopSms.edit') }}
        </el-button>
        <el-button plain size="small" @click="toSmsDetail">
          {{ $t('shopSms.sendDetails') }}
        </el-button>
      </div>
    </div>
    <div class="">
      <el-row>
        <el-col :span="8">
          <div class="form-group">
            <label class="col-form-label">{{ $t('shopSms.remainingSms') }}</label>
            <label>{{ shopConfigSmsInfo.smsCount }}{{ $t('shopSms.unit') }} (<a href="javascript:void(0)"
                @click="openBuySmsModel">{{ $t('shopSms.purchase') }}</a>)</label>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="form-group">
            <label class="col-form-label">{{ $t('shopSms.smsSwitch') }}</label>
            <label>{{ shopConfigSmsInfo.smsSwitch == 'ON' ? $t('shopSms.on') : $t('shopSms.off') }}</label>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="form-group">
            <label class="col-form-label">{{ $t('shopSms.smsPrice') }}</label>
            <label>{{ shopConfigSmsInfo.smsPrice }}{{ $t('shopSms.yuan') }}</label>
          </div>
        </el-col>
      </el-row>
    </div>

    <edit-shop-sms-switch ref="editShopSmsSwitch" @refresh="loadShopConfigSms()"></edit-shop-sms-switch>
    <buy-shop-sms ref="buyShopSms"></buy-shop-sms>
  </el-card>
</template>

<script>
import { getShopSmsList } from '@/api/shop/shopSmsApi'
import EditShopSmsSwitch from '@/components/shop/editShopSmsSwitch/editShopSmsSwitch.vue'
import BuyShopSms from '@/components/shop/buyShopSms/buyShopSms.vue'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'ShopConfigSms',
  components: {
    EditShopSmsSwitch,
    BuyShopSms
  },
  data() {
    return {
      shopConfigSmsInfo: {
        smsId: '',
        shopId: '',
        smsCount: '0',
        smsSwitch: '',
        smsPrice: ''
      }
    }
  },
  created() {
    this.loadShopConfigSms()
  },
  methods: {
    loadShopConfigSms() {
      const params = {
        page: 1,
        row: 1,
        shopId: getShopId()
      }

      getShopSmsList(params).then(res => {
        if (res.data && res.data.length > 0) {
          this.shopConfigSmsInfo = { ...res.data[0] }
        }
      }).catch(error => {
        console.error('请求失败:', error)
      })
    },
    openEditShopSmsSwitchModel() {
      this.$refs.editShopSmsSwitch.open(this.shopConfigSmsInfo)
    },
    openBuySmsModel() {
      this.$refs.buyShopSms.open(this.shopConfigSmsInfo)
    },
    toSmsDetail() {
      this.$router.push('/pages/shop/shopSmsDetail')
    }
  }
}
</script>

<style scoped>
/* 样式与shopConfig.vue保持一致 */
</style>